import { 
    apiBatchExcel,
    apiBatchHouse,
    apiInsertHouseImage,
    apiDelHouseImage
} from "@/apis/api.js"; 

/* 
  這邊可以改為用 types 物件取代 matutions_type.js (繼續用也可以)
  然後在前面加上模組名稱作為前綴，用來避免與其他模組重複。
  因為 action、mutation、和 getter 依然是註冊在全域的命名空間
*/
const types = {
    set_batch_list: 'batchUpload/set_batch_list',
    set_batch_excel: 'batchUpload/set_batch_excel',
    set_image_files: 'batchUpload/set_image_files',
    set_cover: 'batchUpload/set_cover',
    set_file_state: 'batchUpload/set_file_state',
    set_error_file: 'batchUpload/set_error_file',
    set_default: 'batchUpload/set_default',
    set_error_default: 'batchUpload/set_error_default',
    set_fail: 'batchUpload/set_fail',
    set_success: 'batchUpload/set_success',
    set_image_count: 'batchUpload/set_image_count',
    set_upload_image_loop: 'batchUpload/set_upload_image_loop',
    set_modify_images_index: 'batchUpload/set_modify_images_index',
    del_modify_images_index: 'batchUpload/del_modify_images_index',
    set_image_upload_count: 'batchUpload/set_image_upload_count',
    set_image_upload_count_default: 'batchUpload/set_image_upload_count_default',
    set_image_upload_loading: 'batchUpload/set_image_upload_loading',
}

// count state 必須是 Object
const state = {
    houseExcel: [],
    houseBatchInfo: [],
    houseBatchList: [],
    // files: [],
    imageFiles: [],
    imageCount: 0,
    cover: [],
    errorFiles:[],
    fileState: 'done',
    uploadImageLoop: 0,
    modifyImagesIndex: [],
    uploadImageCount: [],
    uploadImageLoading: [],
    error: {
        status: false,
        msg: ''
    },
    success: {
        status: false,
        msg: ''
    }
}

// getters 也可以整理到這邊直接返回 count 內容
const getters = {
    GET_BATCH_LIST: (state) => {
        // if(state.houseExcel && state.houseBatchInfo){
        //     for (let i = 0; i < state.houseBatchInfo.length; i++) {
        //         const element = state.houseExcel[(i+2)];
        //         if(element.length > 0){
        //             console.log(element)
        //             state.houseBatchList.push(element)
        //         }
        //     }
        // }
        // if(state.houseExcel && state.houseBatchInfo){
        //     for (let i = 0; i < state.houseBatchInfo.length; i++) {
        //         const element = state.houseExcel[i+2];
        //         console.log(element)
        //         // if(element.length > 0){
        //             state.houseBatchList.push(element)
        //         // }
        //     }
        // }
        return state.houseBatchInfo
    },
    GET_BATCH_ERROR_LIST: (state) => {
        return state.errorFiles
    },
    GET_BATCH_FAIL: (state) => {
        return state.error
    },
    GET_UPLOAD_IMAGES: (state) => {
        return state.imageFiles
    },
    GET_BATCH_IMAGE_UPLOAD_LOADING: (state) => {
        return state.uploadImageLoading
    },
}

// actions 也是以 Object 形式建構。
const actions = {
    uploadBatch ( {commit, state, dispatch}, data ) {
        return new Promise((resolve, reject) => {
            const files = data.target.files;

            let formData = new FormData();
                formData.append('inputData', files[0]);
            commit(types.set_file_state, 'loading')
            dispatch('setLoadingState', 1)
            apiBatchExcel(formData)
            .then(res => {
                // console.log(res)
                if( res.data.status == "SUCCESS" ){
                    dispatch('setLoadingState', 0)
                    if( res.data.result.length > 0){
                        commit(types.set_batch_list, res.data.result);
                        commit(types.set_file_state, 'done')
                        resolve()
                    }else{
                        commit(types.set_fail, {status: true, msg: '上傳房源失敗，需必填房源名稱'})
                    }
                }else{
                    commit(types.set_fail, {status: true, msg: res.data.errorMsg})
                    dispatch('setLoadingState', 0)
                }
            })
            .catch(err => {
                commit(types.set_file_state, 'fail')
                reject(err)
            })
        })
    },
    setBatchExcle ({commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_batch_excel, data);
        })
    },
    setBatchImageFiles ( {commit, dispatch}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_image_files, data);
            dispatch('setImageCount')
            .then( () => {
                resolve('done')
            })
        })
    },
    setModifyBatchImagesIndex ( {commit, dispatch}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_modify_images_index, data);
            commit(types.set_image_upload_count_default, data);
            commit(types.set_image_upload_loading, {index: data, status: false});
            
            resolve()
        })
    },
    setImageCount ( {commit,state,dispatch}){
        return new Promise((resolve, reject)=>{
            // console.log(state.imageFiles.length)
            let count = 0
            state.imageFiles.map((image, index) => {
                if(image.length > 0){
                    count++
                }
                // console.log('count:'+count)
                // console.log('state:'+state.imageFiles.length)
                // console.log('index:'+(index+1))

                if(state.imageFiles.length == (index+1)){
                    commit(types.set_image_count, count);
                    dispatch('saveBatchImage')
                    .then(()=>{
                        resolve()
                    })
                }
            })
        })
    },
    setBatchCover ( {commit, state}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_cover, data);
            resolve()
        })
    },
    saveBatchCoverImage ( {commit, state}, data ) {
        return new Promise((resolve, reject) => {
            console.log(data)
            let image = state.imageFiles[data.houseIndex][data.index]
            let formData = new FormData();
                formData.append('houseImage', image.file);
                formData.append('houseCid', state.houseBatchInfo[data.houseIndex].cid);
                formData.append('imageSeq', '0');
            apiInsertHouseImage(formData)
            .then(res => {
                // console.log(res)
                if(res.data.status == 'SUCCESS'){
                    // image.imageId = res.data.result.houseImageId
                }
            })
            .catch(err => {
                reject(err)
            })
            resolve()
        })
    },
    saveBatchImage ( {commit, state, dispatch}, data ) {
        return new Promise((resolve, reject) => {
            if(state.imageCount){
                state.modifyImagesIndex.map((imageIndex, index) => {
                    console.log(imageIndex)
                    dispatch('getCurrentUploadImageTotal', imageIndex)
                    .then( (totalUploadImage) => {
                        if(totalUploadImage && totalUploadImage != undefined){
                            state.imageFiles[imageIndex].map((image, index) => {
                                if(image.imageId == undefined){
                                    let formData = new FormData();
                                        formData.append('houseImage', image.file);
                                        formData.append('houseCid', state.houseBatchInfo[imageIndex].cid);
                                        formData.append('imageSeq', '1');
                                    commit(types.set_image_upload_loading, {index: imageIndex, status: true});
                                    apiInsertHouseImage(formData)
                                    .then(res => {
                                        // console.log(res)
                                        commit(types.set_image_upload_count, imageIndex);
                                        if(totalUploadImage == state.uploadImageCount[imageIndex]){
                                            console.log('totalUploadImage')
                                            console.log('uploadCount')
                                            commit(types.set_image_upload_loading, {index: imageIndex, status: false});
                                            commit(types.del_modify_images_index, imageIndex);
                                            resolve()
                                        }
                                        if(res.data.status == 'SUCCESS'){
                                            image.imageId = res.data.result.houseImageId
                                        }
                                    })
                                    .catch(err => {
                                        reject(err)
                                    })
                                }
                            })
                        }else{
                            commit(types.del_modify_images_index, imageIndex);
                        }
                        
                    })
                    
                })
            }
        })
    },
    delBatchImage( {commit,state}, data ) {
        return new Promise((resolve, reject) => {
            let imageId = state.imageFiles[data.houseIndex][data.index].imageId
            let image = '?imageCid='+imageId
            // console.log(image)
            // // console.log(data)
            apiDelHouseImage(image)
            .then(res => {
                // console.log(res)
                if(res.data.status == "SUCCESS"){
                   resolve()
                }else{
                    reject(err)
                }
                
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    getCurrentUploadImageTotal( {commit,state}, imageIndex ) {
        return new Promise((resolve, reject) => {
            let total = 0
            let imageFiles = state.imageFiles[imageIndex]
            console.log()
            if(imageFiles && imageFiles != undefined){
                imageFiles.map((image, index) => {
                    if(image.imageId == undefined){
                        total += 1
                    }
                })
            }
            console.log(total)
            resolve(total)
        })
    },
    saveBatch ( {commit, state, dispatch}, data ) {
        return new Promise((resolve, reject) => {
            dispatch('setLoadingState', 1)
            let imgCount = state.imageCount
            if(state.imageCount){
                state.houseBatchInfo.map( (list, index) => {
                    // index對應圖片index找出該筆excel的houseID
                    if(state.imageFiles[index].length > 0){
                        let formData = new FormData();
                        let houseCid = list.cid,
                            cover = null
                        //把對應到excel的圖片讀出來
                        state.imageFiles[index].map( (image, index2) => {
                            // console.log(image)
                            if(index2 != state.cover[index]){
                                formData.append('bodyImageArray', image.file);
                            }
                        })
                        cover = state.imageFiles[index][state.cover[index]].file
                        
                        formData.append('headImage', cover);
                        formData.append('housesCid', houseCid);
                        // console.log(houseCid)
                        // console.log(images)
                        // console.log(cover)
                        // for (var key of formData.keys()) {
                        //     console.log(key); 
                        //  }
                        // for (var value of formData.values()) {
                        //     console.log(value); 
                        //  }
                        apiBatchHouse(formData)
                        .then(res => {
                            // console.log(res)
                            // console.log('計算數量：'+state.uploadImageLoop)
                            // console.log('圖片數量：'+imgCount)
                            if( res.data.status == "SUCCESS"){
                                commit(types.set_upload_image_loop)
                                if(state.uploadImageLoop == state.imageCount){
                                    dispatch('setLoadingState', 0)
                                    commit(types.set_default)
                                    if(state.errorFiles == 0){
                                        resolve('done')
                                    }
                                }
                            }else{
                                console.log('fail')
                                dispatch('setLoadingState', 0)
                                commit(types.set_fail, {status: true, msg: res.data.errorMsg})
                                commit(types.set_error_file, list)
                            }
                            
                        })
                        .catch(err => {
                            commit(types.set_file_state, 'fail')
                            commit(types.set_error_file, index)
                            reject(err)
                        })
                    }
                })
            }else{
                commit(types.set_default)
                resolve('done')
                dispatch('setLoadingState', 0)
            }
            
        })
    },
    saveErrBatch ( {commit, state, dispatch}, data ) {
        return new Promise((resolve, reject) => {
            let count = 0
            let errorTmp = []
            errorTmp = state.errorFiles
            commit(types.set_error_default)
            dispatch('setLoadingState', 1)
            errorTmp.map( (list, index) => {
                if(state.imageFiles[index].length > 0){
                    count++
                    let formData = new FormData();
                
                    let houseCid = list.cid,
                        cover = null
                    state.imageFiles[index].map( (image, index2) => {
                        if(index2 != state.cover[index]){
                            formData.append('bodyImageArray', image.file);
                        }
                    })
                    cover = state.imageFiles[index][state.cover[index]].file
                    // console.log(houseCid )
                    // console.log(cover)
                    
                    formData.append('headImage', cover);
                    formData.append('housesCid', houseCid);
                    // console.log(houseCid)
                    // console.log(images)
                    // console.log(cover)
                    apiBatchHouse(formData)
                    .then(res => {
                        // console.log(res)
                        if( res.data.status == "SUCCESS"){
                            commit(types.set_upload_image_loop)
                            if(state.uploadImageLoop == state.imageCount){
                                dispatch('setLoadingState', 0)
                                if(state.errorFiles == 0){
                                    commit(types.set_default)
                                    resolve('done')
                                }
                            }
                        }else{
                            console.log('fail')
                            dispatch('setLoadingState', 0)
                            commit(types.set_fail, {status: true, msg: res.data.errorMsg})
                            commit(types.set_error_file, list)
                        }
                    })
                    .catch(err => {
                        commit(types.set_file_state, 'fail')
                        commit(types.set_error_file, index)
                        reject(err)
                    })
                }   
            })
        })
    },
}

// mutations
const mutations = {
    [types.set_batch_list](state, data){
        state.houseBatchInfo = []
        state.houseBatchInfo = data
    },
    [types.set_batch_excel](state, data){
        state.houseExcel = []
        state.houseExcel = data
    },
    [types.set_image_files](state, data){
        let key = Object.keys(data)
        state.imageFiles[key] = data[key]
    },
    [types.set_modify_images_index](state, data){
        // console.log(state.modifyImagesIndex.indexOf(data))
        if(state.modifyImagesIndex.indexOf(data) == -1){
            state.modifyImagesIndex.push(data)
        }
    },
    [types.del_modify_images_index](state, data){
        // console.log(state.modifyImagesIndex.indexOf(data))
        state.modifyImagesIndex.map((item, index) => {
            if(item == data){
                state.modifyImagesIndex.splice(index, 1);
            }
        })
    },
    [types.set_cover](state, data){
        let key = Object.keys(data)
        state.cover[key] = data[key]
    },
    [types.set_file_state](state, data){
        state.fileState = data
    },
    [types.set_error_file](state, data){
        state.errorFiles.push(data)
        state.isFail = true
    },
    [types.set_default](state){
        state.imageFiles = []
        state.imageCount = 0
        state.cover = []
        state.houseExcel = []
        state.houseBatchInfo = []
        state.houseBatchList = []
        state.uploadImageLoop = 0
    },
    [types.set_upload_image_loop](state){
        state.uploadImageLoop += 1
    },
    [types.set_error_default](state){
        state.errorFiles = []
    },
    [types.set_fail](state, data){
        if(data.status){
            state.error.status = data.status
            state.error.msg = data.msg
        }else{
            state.error.status = false
            state.error.msg = null
        }
    },
    [types.set_success](state, data){
        state.isFail = data
    },
    [types.set_image_count](state, data){
        state.imageCount = data
    },
    [types.set_image_upload_count](state, data){
        state.uploadImageCount[data] += 1 
    },
    [types.set_image_upload_count_default](state, data){
        state.uploadImageCount[data] = 0 
    },
    [types.set_image_upload_loading](state, data){
        state.uploadImageLoading[data.index] = data.status 
    }
}

/*
因為我們把 vuex 所有職權都寫在同一隻檔案，
所以必須要 export 出去給最外層 index.js 組合使用
*/
export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/landlord/batchUpload.js